import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GOLF_COURSE_SLOTS, GET_GOLF_COURSE_SLOTS_SUCCESS, GET_GOLF_COURSE_SLOTS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getGolfCourseSlots({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-slots`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      if (response?.data?.slotDates === null) {
        cogoToast.error(`Data not found`);
      }
      yield put({
        type: GET_GOLF_COURSE_SLOTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_COURSE_SLOTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_COURSE_SLOTS_ERROR, payload: error });
  }
}

export function* watchGetGolfCourseSlots() {
  yield takeEvery(GET_GOLF_COURSE_SLOTS, getGolfCourseSlots);
}

function* getGolfCourseSlotsSaga() {
  yield all([fork(watchGetGolfCourseSlots)]);
}

export default getGolfCourseSlotsSaga;
